const locale = {
    placeholder: 'Zgjidh kohën',
    rangePlaceholder: ['Koha e fillimit', 'Koha e mbarimit'],
};
export default locale;
